const SwingGauge = ({ score, size = 200 }) => {
  const strokeWidth = 12;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const offset = circumference - (score / 100) * circumference;

  // Color based on score
  const getColor = (score) => {
    if (score >= 80) return "#CCFF00"; // Excellent
    if (score >= 60) return "#A8D900"; // Good
    if (score >= 40) return "#FFD60A"; // Average
    return "#FF3B30"; // Needs work
  };

  const color = getColor(score);

  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="swing-gauge">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="transform -rotate-90"
      >
        {/* Background track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#262626"
          strokeWidth={strokeWidth}
          className="gauge-track"
        />
        
        {/* Progress arc */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="gauge-fill"
          style={{
            transition: "stroke-dashoffset 1s ease-out, stroke 0.5s ease",
          }}
        />

        {/* Tick marks */}
        {[0, 25, 50, 75, 100].map((tick) => {
          const angle = (tick / 100) * 360 - 90;
          const x1 = size / 2 + (radius - 20) * Math.cos((angle * Math.PI) / 180);
          const y1 = size / 2 + (radius - 20) * Math.sin((angle * Math.PI) / 180);
          const x2 = size / 2 + (radius - 8) * Math.cos((angle * Math.PI) / 180);
          const y2 = size / 2 + (radius - 8) * Math.sin((angle * Math.PI) / 180);
          
          return (
            <line
              key={tick}
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="#A3A3A3"
              strokeWidth="2"
            />
          );
        })}
      </svg>

      {/* Center content */}
      <div 
        className="absolute inset-0 flex flex-col items-center justify-center"
        style={{ transform: "rotate(0deg)" }}
      >
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">
          Score
        </span>
      </div>

      {/* Glow effect for high scores */}
      {score >= 80 && (
        <div 
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            background: `radial-gradient(circle, ${color}10 0%, transparent 70%)`,
          }}
        />
      )}
    </div>
  );
};

export default SwingGauge;
